import React, { useContext } from "react";
import ManageMembershipItem from "./ManageMembershipItem";
import UserContext from "../context/users.context";
import SitesContext from "../context/sites.context";

const ManageMemberships = ({ dispatch }) => {
  const user = useContext(UserContext);
  const sites = useContext(SitesContext);
  return (
    <>
      <div className="headline_panel">
        <h2 className="title">Manage Memberships</h2>
      </div>
      <div className="list_thumbs">
        {user && sites
          ? user.map((u, i) => (
              <ManageMembershipItem
                site={sites[u.siteid]}
                user={u}
                i={i}
                dispatch={dispatch}
                key={`mmi${u.siteid}`}
              />
            ))
          : null}
      </div>
    </>
  );
};

export default ManageMemberships;
